import React from 'react';
import '../styles/MapPerformanceTable.css';

const LastModeMatchesTable = ({ data, limit, onLimitChange, mode }) => {
  if (!data || data.length === 0) {
    return <p className="last-games-empty">No {mode} matches in the selected range.</p>;
  }

  const formatDate = (iso) => {
    const d = new Date(iso);
    return isNaN(d)
      ? '-'
      : d.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        });
  };

  const calculatePercent = (wins, losses) => {
    const w = parseInt(wins);
    const l = parseInt(losses);
    const total = w + l;
    if (isNaN(total) || total === 0) return '—';
    return `${((w / total) * 100).toFixed(1)}%`;
  };

  const calculateDiff = (pf, pa) => {
    const diff = parseInt(pf) - parseInt(pa);
    return isNaN(diff) ? '-' : diff > 0 ? `+${diff}` : `${diff}`;
  };

  return (
    <div className="map-performance-container">
      <div className="table-wrapper">
        <table className="performance-table performance-table--last">
          <thead>
            <tr>
              <th>Date</th>
              <th>Opponent</th>
              <th>Match Type</th>
              <th>Map</th>
              <th>Result</th>
              <th>PF</th>
              <th>PA</th>
              <th>[+/-]</th>
              {mode !== 'HP' && <th>Off Win %</th>}
              {mode !== 'HP' && <th>Def Win %</th>}
            </tr>
          </thead>
          <tbody>
            {data.map((match, idx) => (
              <tr
                key={idx}
                className={
                  match.WinLose === 'WIN'
                    ? 'win-row'
                    : match.WinLose === 'LOSE'
                    ? 'loss-row'
                    : ''
                }
              >
                <td>{formatDate(match.Date)}</td>
                <td>{match.EnemyTeam}</td>
                <td>{match.MatchType}</td>
                <td>{match.Map}</td>
                <td style={{ fontWeight: 'bold' }}>{match.WinLose}</td>
                <td>{match.PF}</td>
                <td>{match.PA}</td>
                <td>{calculateDiff(match.PF, match.PA)}</td>
                {mode !== 'HP' && (
                  <>
                    <td>{calculatePercent(match.OffWins, match.OffLosses)}</td>
                    <td>{calculatePercent(match.DefWins, match.DefLosses)}</td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LastModeMatchesTable;
